var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-video-container",
      attrs: { id: "product-video-container" }
    },
    [
      _c(
        "div",
        { staticClass: "product-video", attrs: { id: "product-video" } },
        [
          _c(
            "div",
            {
              staticClass: "video-js-container vjs-default-skin",
              attrs: {
                with_theatrical_btn: false,
                "data-sources": JSON.stringify(_vm.hlsSources),
                "data-poster": _vm.poster,
                "data-text_tracks": JSON.stringify(_vm.textTracks),
                "data-id": _vm.uploadedVideo.id,
                holder: JSON.stringify(_vm.holderData)
              }
            },
            [
              _c(
                "video",
                {
                  ref: "videoPlayer",
                  staticClass: "video-js",
                  attrs: {
                    controls: true,
                    preload: "auto",
                    width: "100%",
                    height: "100%",
                    poster: _vm.poster
                  }
                },
                [
                  _c("source", {
                    attrs: {
                      src: _vm.hlsSources[0],
                      type: "application/x-mpegURL"
                    }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.textTracks, function(track, i) {
                    return _c("track", {
                      key: i,
                      attrs: {
                        kind: track.kind,
                        src: track.src,
                        srclang: track.srclang,
                        label: track.label
                      }
                    })
                  })
                ],
                2
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }